import { List } from 'immutable';
import * as React from 'react';
import Select from 'react-select';

import { actions } from '../../../../ducks/MessageForm';
import { SimpleFormSelect, SimpleFormString } from '../../../../lib/components/SimpleForm';
import { getDispatch } from '../../../../lib/dispatchExporter';
import I18n from '../../../../lib/i18n';
import notify from '../../../../lib/notify';
import ProductList from '../../../../models/ProductList';
import ProductDragContainer from '../../DragComponents/ProductDragContainer';
import MoreShopQuery from '../../../../models/MoreShopQuery';

interface IProps {
  index: number;
  parentFormName: string;
  countries: List<{ iso2: string }>;
  platforms: string[];
  products: ProductList;
  listName?: string;
  listType?: string;
  featuredProductIds: List<string>;
  displayType: string;
  updateShopJumpQuery: (key: string, value: string) => void;
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  onFocus?: () => void;
  hasNxNewsFormLevel: boolean;
  moreShopQuery: MoreShopQuery;
}
interface IState {
  nsUid: string;
}
export default class ProductListForm extends React.PureComponent<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    this.state = {
      nsUid: '',
    };
  }

  private dispatch = getDispatch();

  private limitExceeded = () => {
    const { products } = this.props;
    const maxProductsLength = (window as any).Constants.validators.message.moreShopQuery.listIdsSize;
    return products.productListLimitExceeded(maxProductsLength, I18n.t('activerecord.hints.message_detail.more_shop_query.list'));
  }

  private notifyProductNotFound = () => {
    notify({
      title: '',
      message: I18n.t('message_details.error.product_not_found'),
      type: 'danger'
    });
  }

  public selectProduct = (option: { value: string }) => {
    const { index } = this.props;
    if (this.limitExceeded()) {
      return;
    }
    this.dispatch(actions.selectShopList({ productId: option.value, index }));
  }

  public handleSort = (index: number) => ({ oldIndex, newIndex }: { oldIndex: number, newIndex: number }) => {
    this.dispatch(actions.sortShopLists({ index, oldIndex, newIndex }));
  }

  public handleUnselect = (index: number) => (id: string) => {
    this.dispatch(actions.unselectShopList({ productId: id, index }));
  }

  public handleCopyFeaturedProductsClick = () => {
    const { index, featuredProductIds } = this.props;
    this.dispatch(actions.copyFeaturedProductsToShopLinkList({ index, nsUids: featuredProductIds }));
  }

  public renderCopyFeaturedProductsBtn() {
    const { featuredProductIds, displayType } = this.props;
    if (displayType === 'NORMAL' || featuredProductIds.size === 0) { return null; }
    return (
      <div
        className="btn btn-primary"
        onClick={this.handleCopyFeaturedProductsClick}
        style={{marginLeft: '10px'}}
      >
        { I18n.t('message_details.form.copy_featured_products_to_shop_list_link') }
      </div>
    );
  }

  public handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ nsUid : e.target.value });
  }

  public handleClick = () => {
    if (this.limitExceeded()) {
      return; 
    }
    const nsUid = this.state.nsUid.trim();
    if (!nsUid) {
      this.notifyProductNotFound();
      return;
    }
    const { products, index, moreShopQuery, platforms } = this.props;
    // 重複チェック
    if (products.selectedIds.includes(nsUid)) {
      this.dispatch(actions.fetchShopProductByIdFailed({index, message: I18n.t('message_details.error.product_duplicated')}));
      notify({
        title: '',
        message: I18n.t('message_details.error.product_duplicated'),
        type: 'danger',
      });
      return;
    }
    this.dispatch(actions.fetchShopProductByIdRequest({
      nsUid,
      key: undefined,
      index, 
      moreShopQuery, 
      platforms,
      afterFetch: (succeeded: boolean) => {
        if (succeeded) {
          this.setState({nsUid: ''});
        } else {
          this.notifyProductNotFound();
        }
      }
    }));
  }

  public render() {
    const {
      index,
      products,
      parentFormName: prevParentFormName,
      listName,
      listType,
      handleChange,
      countries,
      platforms,
      onFocus,
      hasNxNewsFormLevel,
    } = this.props;
    const { nsUid } = this.state;
    const types = (window as any).Constants.message.moreShopQuery.listTypes.map((e: string) => [e, e]);
    const parentFormName = `${prevParentFormName}[list_ids][]`;
    const maxLength = (window as any).Constants.validators.message.moreShopQuery.listNameLength;
    const listNameLength = listName ? listName.length : 0;
    const length = `${listNameLength}/${maxLength}`;
    const error = maxLength < listNameLength ? [''] : undefined;
    return (
      <div>
        <div className="col-md-12">
          <SimpleFormString
            label={I18n.t('activerecord.attributes.message_detail.list_name')}
            value={listName || ''}
            name={`${prevParentFormName}[list_name]`}
            onChange={handleChange}
            helpMessage={length}
            errorMessage={error}
          />
        </div>
        {/* 現在は選択の余地がないので表示しない */}
        <div className="col-md-2" style={{ display: 'none' }}>
          <SimpleFormSelect
            name={`${prevParentFormName}[list_type]`}
            label={''}
            values={types}
            value={listType || ''}
            onChange={handleChange}
          />
        </div>

        <div className="col-md-12">
          <div className="row">
            { hasNxNewsFormLevel ? 
              <>
                <div className="col-md-7">
                  <input
                    type="text"
                    name="product-list-form-ns-uid"
                    placeholder={I18n.t('message_details.form.fetch_product_by_id_placeholder')} 
                    value={nsUid}
                    className="form-control"
                    onChange={this.handleChange} />
                </div>
                <div className="col-md-5" style={{ marginBottom: '10px' }}>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={this.handleClick}
                    disabled={!nsUid || products.isFetching || countries.size < 1}
                  >
                    {I18n.t('common.action.add')}
                  </button>
                  { this.renderCopyFeaturedProductsBtn() }
                </div>
                <div className="col-md-5" style={{ marginBottom: '10px' }}>
                </div>
              </>
            :
              <div className="col-md-10">
                <Select
                  name="related-products-select"
                  options={products.filterAvailableCountries(countries.map(c => c.iso2).toArray(), platforms)}
                  onChange={this.selectProduct}
                  onFocus={onFocus}
                />
              </div>
            }
          </div>
        </div>
        <div style={ hasNxNewsFormLevel ? undefined : { marginTop: '10px' }} className="col-md-12">
          <ProductDragContainer
            $$products={products}
            countries={countries}
            sortProducts={this.handleSort(index)}
            unselectProduct={this.handleUnselect(index)}
            platforms={platforms}
            {...{ parentFormName }}
          />
        </div>
      </div>
    );
  }
}
